import React from 'react';

function Videos() {
    return (
        <div>
            <h2>Videos</h2>
            <p>Educational videos coming soon!</p>
        </div>
    );
}

export default Videos;